import { useFeature } from '@/apiHooks/featureSwitches.hook';
import { Feature } from '@/@types/featureSwitch';
import { isFeatureFlagEnabled } from '@/utils/isFeatureFlagEnabled.util';

export const useUpgradeTouchpointEnabled = () => {
  const isEnabled =
    useFeature(Feature.BIZ_9692_ENABLE_UPGRADE_TOUCHPOINT) ||
    isFeatureFlagEnabled(Feature.BIZ_9692_ENABLE_UPGRADE_TOUCHPOINT);

  return {
    isEnabled,
  };
};
